<template>
  <svg
    viewBox="0 0 204.32 54"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    :class="{ white }"
  >
    <path
      d="m4.36 19.13h7.15v3.46h-11.51v-21.72h4.36z"
      transform="translate(0 -.16)"
    />
    <path
      d="m34.92 18.44h-8.65l-1.43 4.14h-4.58l7.81-21.75h5.08l7.8 21.75h-4.6zm-1.18-3.48-3.15-9.09-3.14 9.09z"
      transform="translate(-3.61 -.15)"
    />
    <path
      d="m70.82 22.58h-4.35l-9.87-14.9v14.9h-4.36v-21.75h4.36l9.86 14.94v-14.94h4.36z"
      transform="translate(-9.32 -.15)"
    />
    <path
      d="m117.7 4.38v5.44h7.31v3.46h-7.31v5.75h8.25v3.55h-12.6v-21.75h12.6v3.55z"
      transform="translate(-20.24 -.15)"
    />
    <path
      d="m156.19 22.58h-4.36l-9.87-14.9v14.9h-4.35v-21.75h4.35l9.87 14.94v-14.94h4.36z"
      transform="translate(-24.56 -.15)"
    />
    <path
      d="m186.96.87v21.72h-4.36v-9.24h-9.3v9.24h-4.36v-21.72h4.36v8.93h9.3v-8.93z"
      transform="translate(-30.16 -.16)"
    />
    <path
      d="m245.8.87v3.51h-9.05v5.57h6.93v3.46h-6.94v9.18h-4.35v-21.72z"
      transform="translate(-41.49 -.16)"
    />
    <circle cx="173.93" cy="15.68" fill="#3257A4" r="4.43" />
    <path
      d="m220.54 11.25h-4.08a7.16 7.16 0 0 0 -14.33 0h-4.08a11.25 11.25 0 0 1 22.5 0z"
      transform="translate(-35.35)"
    />
    <circle cx="71.5" cy="11.39" fill="#3257A4" r="4.43" />
    <path
      d="m92.44 22.68v-4.1a7.16 7.16 0 0 0 0-14.31v-4.09a11.25 11.25 0 1 1 0 22.5z"
      transform="translate(-16.5 -.03)"
    />
    <g fill="#3257A4" transform="translate(75.78 30.98)">
      <path
        d="m98.68 45.63v1.1h-6.43v-1.05l4.82-5.82h-4.71v-1.1h6.18v1.06l-4.82 5.8z"
        transform="translate(-92.25 -37.9)"
      />
      <path
        d="m106.98 44.59h-4.42a1.92 1.92 0 0 0 .57 1.21 1.69 1.69 0 0 0 1.18.42 2.06 2.06 0 0 0 .98-.21 1.1 1.1 0 0 0 .54-.61l1.08.44a2.6 2.6 0 0 1 -2.6 1.4 2.95 2.95 0 0 1 -2.22-.83 3.18 3.18 0 0 1 -.8-2.3 3.25 3.25 0 0 1 .77-2.3 2.83 2.83 0 0 1 2.17-.84 2.65 2.65 0 0 1 2.06.81 3.07 3.07 0 0 1 .74 2.15 4.49 4.49 0 0 1 -.05.66zm-3.88-2.19a1.98 1.98 0 0 0 -.54 1.2h3.26a1.99 1.99 0 0 0 -.51-1.18 1.45 1.45 0 0 0 -1.08-.42 1.56 1.56 0 0 0 -1.13.4z"
        transform="translate(-93.86 -38.3)"
      />
      <path
        d="m115.12 41.55a2.14 2.14 0 0 1 .64 1.66v3.91h-1.3v-3.5q0-1.59-1.29-1.6a1.61 1.61 0 0 0 -1.15.47 1.9 1.9 0 0 0 -.49 1.43v3.2h-1.29v-6.02h1.15l.06 1a1.96 1.96 0 0 1 .83-.84 2.56 2.56 0 0 1 1.2-.28 2.33 2.33 0 0 1 1.64.58z"
        transform="translate(-95.46 -38.3)"
      />
      <path
        d="m123 46.37a2.15 2.15 0 0 1 -.7.38 2.84 2.84 0 0 1 -.9.13 2.02 2.02 0 0 1 -1.34-.41 1.62 1.62 0 0 1 -.51-1.3v-3.43h-1.15v-1h1.15v-1.42l1.29-.36v1.77h2.1v1.02h-2.1v3.2a.83.83 0 0 0 .23.65.93.93 0 0 0 .65.21 1.4 1.4 0 0 0 .98-.38z"
        transform="translate(-96.92 -37.93)"
      />
      <path
        d="m129.25 41.09-.2 1.18a1.55 1.55 0 0 0 -.76-.15 1.4 1.4 0 0 0 -.73.2 1.57 1.57 0 0 0 -.57.61 2.04 2.04 0 0 0 -.22 1v3.2h-1.3v-6.04h1.1l.11 1.09a1.89 1.89 0 0 1 1.91-1.21 1.52 1.52 0 0 1 .66.12z"
        transform="translate(-98.18 -38.3)"
      />
      <path
        d="m137 41.12v6.03h-1.15l-.04-.98a2.62 2.62 0 0 1 -3.73.56 2.1 2.1 0 0 1 -.6-1.64v-3.97h1.3v3.63a1.63 1.63 0 0 0 .3 1.13 1.22 1.22 0 0 0 .94.33 1.66 1.66 0 0 0 1.21-.47 1.83 1.83 0 0 0 .48-1.37v-3.25z"
        transform="translate(-99.26 -38.32)"
      />
      <path
        d="m149.03 41.22a1.9 1.9 0 0 1 .8.75 2.39 2.39 0 0 1 .3 1.24v3.91h-1.29v-3.7a1.43 1.43 0 0 0 -.33-1.05 1.22 1.22 0 0 0 -.91-.33 1.47 1.47 0 0 0 -1.11.48 1.86 1.86 0 0 0 -.46 1.32v3.29h-1.29v-3.7a1.43 1.43 0 0 0 -.34-1.05 1.22 1.22 0 0 0 -.9-.34 1.54 1.54 0 0 0 -.74.2 1.5 1.5 0 0 0 -.6.62 2.22 2.22 0 0 0 -.22 1.06v3.21h-1.3v-6.03h1.15l.06 1a2.03 2.03 0 0 1 .82-.84 2.33 2.33 0 0 1 1.13-.28 2.46 2.46 0 0 1 1.23.3 1.9 1.9 0 0 1 .81.9 1.91 1.91 0 0 1 .85-.9 2.56 2.56 0 0 1 1.23-.3 2.51 2.51 0 0 1 1.1.25z"
        transform="translate(-100.89 -38.3)"
      />
      <path
        d="m160.68 40.5h1.96v1.02h-1.92v5.02h-1.3v-5.02h-1.13v-1.01h1.14v-.87a1.83 1.83 0 0 1 .55-1.42 2.22 2.22 0 0 1 1.56-.51 2.63 2.63 0 0 1 .66.08 1.3 1.3 0 0 1 .47.2l-.24.95a1.23 1.23 0 0 0 -.69-.18q-1.06 0-1.06.98z"
        transform="translate(-104.04 -37.71)"
      />
      <path
        d="m170.44 40.6v6.02h-1.14l-.05-.97a2.62 2.62 0 0 1 -3.72.56 2.1 2.1 0 0 1 -.6-1.65v-3.96h1.3v3.63a1.63 1.63 0 0 0 .3 1.13 1.22 1.22 0 0 0 .93.33 1.66 1.66 0 0 0 1.22-.46 1.83 1.83 0 0 0 .47-1.37v-3.26zm-3.4-2.22a.82.82 0 0 1 0 1.12.81.81 0 0 1 -.58.2.78.78 0 0 1 -.56-.22.81.81 0 0 1 0-1.1.8.8 0 0 1 .56-.2.81.81 0 0 1 .58.2zm2.44 0a.82.82 0 0 1 0 1.12.81.81 0 0 1 -.58.2.8.8 0 0 1 -.57-.2.84.84 0 0 1 0-1.12.8.8 0 0 1 .57-.2.81.81 0 0 1 .58.2z"
        transform="translate(-105.23 -37.8)"
      />
      <path
        d="m177.86 41.09-.2 1.18a1.54 1.54 0 0 0 -.77-.15 1.4 1.4 0 0 0 -.73.2 1.57 1.57 0 0 0 -.57.61 2.04 2.04 0 0 0 -.22 1v3.2h-1.29v-6.04h1.1l.1 1.09a1.89 1.89 0 0 1 1.92-1.21 1.52 1.52 0 0 1 .66.12z"
        transform="translate(-106.86 -38.3)"
      />
      <path
        d="m191.37 38.77v7.96h-1.3v-3.47h-3.93v3.47h-1.3v-7.96h1.3v3.38h3.93v-3.38z"
        transform="translate(-108.78 -37.9)"
      />
      <path
        d="m200.12 41.3a3.73 3.73 0 0 1 0 4.6 3.35 3.35 0 0 1 -4.42 0 3.73 3.73 0 0 1 0-4.6 3.35 3.35 0 0 1 4.42 0zm-2.85-2.92a.82.82 0 0 1 0 1.11.81.81 0 0 1 -.58.2.78.78 0 0 1 -.57-.21.8.8 0 0 1 0-1.1.8.8 0 0 1 .57-.2.81.81 0 0 1 .58.2zm-.62 3.65a3.04 3.04 0 0 0 0 3.15 1.72 1.72 0 0 0 2.52 0 2.98 2.98 0 0 0 0-3.14 1.72 1.72 0 0 0 -2.52-.01zm3.06-3.65a.82.82 0 0 1 0 1.11.81.81 0 0 1 -.58.2.79.79 0 0 1 -.58-.2.84.84 0 0 1 0-1.11.79.79 0 0 1 .58-.2.81.81 0 0 1 .58.2z"
        transform="translate(-110.58 -37.8)"
      />
      <path
        d="m208 41.09-.2 1.18a1.54 1.54 0 0 0 -.76-.15 1.4 1.4 0 0 0 -.73.2 1.57 1.57 0 0 0 -.57.61 2.03 2.03 0 0 0 -.22 1v3.2h-1.29v-6.04h1.1l.1 1.09a1.88 1.88 0 0 1 1.91-1.21 1.51 1.51 0 0 1 .66.12z"
        transform="translate(-112.24 -38.3)"
      />
      <path
        d="m215.39 44.59h-4.42a1.92 1.92 0 0 0 .57 1.21 1.69 1.69 0 0 0 1.18.42 2.06 2.06 0 0 0 .98-.21 1.1 1.1 0 0 0 .54-.61l1.07.44a2.6 2.6 0 0 1 -2.59 1.4 2.95 2.95 0 0 1 -2.22-.83 3.18 3.18 0 0 1 -.8-2.3 3.26 3.26 0 0 1 .77-2.3 2.83 2.83 0 0 1 2.17-.84 2.65 2.65 0 0 1 2.06.81 3.07 3.07 0 0 1 .74 2.15 4.37 4.37 0 0 1 -.05.66zm-3.88-2.18a1.97 1.97 0 0 0 -.54 1.2h3.26a1.98 1.98 0 0 0 -.51-1.19 1.45 1.45 0 0 0 -1.08-.42 1.57 1.57 0 0 0 -1.13.4z"
        transform="translate(-113.22 -38.3)"
      />
      <path
        d="m223.53 41.55a2.14 2.14 0 0 1 .63 1.66v3.91h-1.29v-3.5q0-1.59-1.29-1.6a1.61 1.61 0 0 0 -1.16.47 1.9 1.9 0 0 0 -.48 1.43v3.2h-1.29v-6.02h1.15l.06 1a1.95 1.95 0 0 1 .83-.84 2.56 2.56 0 0 1 1.2-.28 2.33 2.33 0 0 1 1.64.58z"
        transform="translate(-114.82 -38.3)"
      />
      <path
        d="m98.2 58.24v6.04h-1.16l-.04-.98a2.62 2.62 0 0 1 -3.72.56 2.1 2.1 0 0 1 -.6-1.65v-3.97h1.29v3.64a1.63 1.63 0 0 0 .31 1.13 1.22 1.22 0 0 0 .93.33 1.66 1.66 0 0 0 1.22-.47 1.82 1.82 0 0 0 .47-1.37v-3.26z"
        transform="translate(-92.33 -41.38)"
      />
      <path
        d="m106.7 58.68a2.14 2.14 0 0 1 .64 1.66v3.91h-1.3v-3.5q0-1.59-1.28-1.6a1.61 1.61 0 0 0 -1.16.47 1.9 1.9 0 0 0 -.48 1.43v3.2h-1.3v-6.03h1.15l.07 1a1.95 1.95 0 0 1 .83-.84 2.56 2.56 0 0 1 1.2-.28 2.33 2.33 0 0 1 1.64.58z"
        transform="translate(-93.96 -41.35)"
      />
      <path
        d="m116.43 54.94v8.75h-1.13l-.07-1.08a2.06 2.06 0 0 1 -.8.87 2.32 2.32 0 0 1 -1.23.33 2.46 2.46 0 0 1 -1.96-.83 3.4 3.4 0 0 1 -.72-2.3 3.44 3.44 0 0 1 .72-2.3 2.44 2.44 0 0 1 1.96-.85 2.27 2.27 0 0 1 1.17.3 1.97 1.97 0 0 1 .78.8v-3.69zm-1.74 7.29a2.27 2.27 0 0 0 .45-1.49v-.14a2.25 2.25 0 0 0 -.44-1.48 1.63 1.63 0 0 0 -2.44.01 2.4 2.4 0 0 0 -.44 1.54 2.42 2.42 0 0 0 .44 1.55 1.62 1.62 0 0 0 2.44 0z"
        transform="translate(-95.51 -40.79)"
      />
      <path
        d="m129.6 56.15a3.4 3.4 0 0 1 1.3 1.22l-.98.88a2.4 2.4 0 0 0 -.84-1.05 2.48 2.48 0 0 0 -1.35-.33 2.17 2.17 0 0 0 -1.3.33 1 1 0 0 0 -.45.85.87.87 0 0 0 .45.77 4.81 4.81 0 0 0 1.59.49 7.18 7.18 0 0 1 1.7.49 2.15 2.15 0 0 1 .93.73 1.95 1.95 0 0 1 .29 1.1 2 2 0 0 1 -.4 1.23 2.5 2.5 0 0 1 -1.12.81 4.5 4.5 0 0 1 -1.66.28 3.7 3.7 0 0 1 -3.42-1.61l.9-.9a2.54 2.54 0 0 0 1 1.06 3.1 3.1 0 0 0 1.51.33 2.6 2.6 0 0 0 1.34-.29.93.93 0 0 0 .5-.84.8.8 0 0 0 -.45-.7 5.03 5.03 0 0 0 -1.54-.47 7.62 7.62 0 0 1 -1.74-.5 2.22 2.22 0 0 1 -.95-.75 1.93 1.93 0 0 1 -.3-1.1 2.15 2.15 0 0 1 .37-1.22 2.55 2.55 0 0 1 1.08-.88 3.9 3.9 0 0 1 1.65-.33 4.08 4.08 0 0 1 1.88.4z"
        transform="translate(-97.98 -40.93)"
      />
      <path
        d="m139.62 61.72h-4.41a1.92 1.92 0 0 0 .56 1.21 1.7 1.7 0 0 0 1.19.42 2.06 2.06 0 0 0 .98-.21 1.1 1.1 0 0 0 .54-.61l1.07.44a2.6 2.6 0 0 1 -2.6 1.4 2.95 2.95 0 0 1 -2.22-.83 3.18 3.18 0 0 1 -.8-2.3 3.26 3.26 0 0 1 .77-2.31 2.83 2.83 0 0 1 2.18-.83 2.65 2.65 0 0 1 2.06.81 3.07 3.07 0 0 1 .73 2.15 4.27 4.27 0 0 1 -.05.66zm-3.88-2.18a1.97 1.97 0 0 0 -.53 1.2h3.26a1.98 1.98 0 0 0 -.52-1.19 1.45 1.45 0 0 0 -1.08-.42 1.57 1.57 0 0 0 -1.13.4z"
        transform="translate(-99.7 -41.35)"
      />
      <path
        d="m147.77 58.11a2.14 2.14 0 0 1 .63 1.67v3.9h-1.29v-3.5q0-1.58-1.3-1.59a1.6 1.6 0 0 0 -1.15.48 1.92 1.92 0 0 0 -.48 1.43v3.19h-1.3v-8.75h1.3v3.68a1.95 1.95 0 0 1 .8-.82 2.43 2.43 0 0 1 1.15-.27 2.33 2.33 0 0 1 1.64.58z"
        transform="translate(-101.3 -40.79)"
      />
      <path
        d="m157.25 61.72h-4.42a1.92 1.92 0 0 0 .57 1.21 1.69 1.69 0 0 0 1.18.42 2.06 2.06 0 0 0 .98-.21 1.1 1.1 0 0 0 .54-.61l1.08.44a2.6 2.6 0 0 1 -2.6 1.4 2.95 2.95 0 0 1 -2.22-.83 3.18 3.18 0 0 1 -.8-2.3 3.25 3.25 0 0 1 .77-2.31 2.82 2.82 0 0 1 2.17-.83 2.65 2.65 0 0 1 2.06.81 3.07 3.07 0 0 1 .74 2.15 4.38 4.38 0 0 1 -.05.66zm-3.88-2.18a1.97 1.97 0 0 0 -.54 1.2h3.26a1.99 1.99 0 0 0 -.51-1.19 1.45 1.45 0 0 0 -1.08-.42 1.56 1.56 0 0 0 -1.13.4z"
        transform="translate(-102.84 -41.35)"
      />
      <path
        d="m165.39 58.68a2.14 2.14 0 0 1 .63 1.66v3.91h-1.29v-3.5q0-1.59-1.29-1.6a1.61 1.61 0 0 0 -1.16.47 1.9 1.9 0 0 0 -.48 1.43v3.2h-1.29v-6.03h1.15l.06 1a1.95 1.95 0 0 1 .83-.84 2.56 2.56 0 0 1 1.2-.28 2.33 2.33 0 0 1 1.64.58z"
        transform="translate(-104.44 -41.35)"
      />
    </g>
  </svg>
</template>

<script setup>
defineProps({
  white: Boolean,
})
</script>

<style scoped>
.white * {
  fill: white;
}
</style>
